<template>
  <!-- 详细信息弹窗 -->
  <div>
    <van-popup v-model="showModel"  round :close-on-click-overlay="false">
    <!-- <div class="showD" v-if="showModel"> -->
      <div class="content">
        <!-- <div class="circle"></div> -->
        <div class="ti">
          支付提醒
          <div class="close" @click="closeDialog">×</div>
        </div>
        <div style="padding: 0 20px;" class="cBox">
          <div class="cont" v-html="content">
          </div>
          <div style=" margin-top:8px;">
            <!-- <p v-if="isShowPhone" class="notice">
              *填写手机号码用于查询电子发票。
            </p> -->
            <van-form ref="formPhone">
              <!-- <div v-if="isShowPhone"  class="phoneBox">
                <van-field
                  v-model="phone"
                  type="text"
                  label="手机号码"
                  :rules="[{ validator, message: '请输入正确格式手机号' }]"
                  placeholder="请输入手机号"
                />
                <img src="../assets/img/bjicon.png" alt="">
              </div>
              <div v-if="isBill"  class="billBox">
                <van-field
                  v-if="isBill"
                  readonly
                  v-model="payerTypeName"
                  @click="showType = true"
                  label="缴款人类型"
                  placeholder="请选择缴款人类型"
                />
                <img src="../assets/img/bjicon.png" alt="">
              </div> -->
              <!-- 退费记录代码 -->
              <div v-if="isRefNotice"  class="phoneBox">
                <div class="phLabel">考生姓名</div>
                <van-field
                  v-model="payer"
                  type="text"
                  maxlength="50"
                  label=""
                  disabled
                  placeholder=""
                />
              </div>
              <div v-if="isRefNotice" class="phoneBox">
                <div class="phLabel">收款银行</div>
                <van-field
                  v-model="receiveBank"
                  type="text"
                  maxlength="50"
                  label=""
                  :rules="[{ required: true }]"
                  placeholder="如:中国建设银行"
                />
              </div>
              <div v-if="isRefNotice"  class="phoneBox">
                <div class="phLabel">开户行支行名称</div>
                <van-field
                  v-model="accountBank"
                  type="text"
                  maxlength="50"
                  label=""
                  :rules="[{ required: true}]"
                  placeholder="如:重庆江北观音桥支行"
                />
              </div>
              <div v-if="isRefNotice"  class="phoneBox">
                <div class="phLabel">开户行卡号</div>
                <van-field
                  maxlength="19"
                  v-model="accountNumber"
                  type="number"
                  label=""
                  :rules="[{ required: true}]"
                  placeholder="务必填写准确"
                />
              </div>
            </van-form>
          </div>
        </div>

        <div class="butarea">
          <!-- <div class="rbutton cancel">取消支付</div> -->
          <van-button
            @click="closeDialog"
            class="cancel"
            round
            plain
            color="#999"
            >取消支付</van-button
          >
          <van-button @click="confirmPay" class="confirm" round type="info"
            >继续支付</van-button
          >
        </div>
      <!-- </div> -->
    </div>

    </van-popup>

    <!-- <van-dialog v-model="showModel" title="温馨提示"
      :before-close='closePay'
      show-cancel-button 
      confirm-button-text='确认支付'
      cancel-button-text='关闭'>
       <p  v-if='isShowPhone' class="notice">*填写手机号码后，可用该手机号码查询电子发票。</p>
        <van-form ref="formPhone">
            <van-field v-if='isShowPhone'
                v-model="phone"
                type="text"
                label="手机号码"
                :rules="[{ validator, message: '请输入正确格式手机号' }]"
                placeholder="请输入手机号"
            />
            <van-field v-if='isBill' readonly
                v-model="payerTypeName"
                @click="showType=true"
                label="缴款人类型"
                placeholder="请选择缴款人类型"
            />
            </van-form>
    </van-dialog> -->
    <!-- <van-popup v-model="showType" position="bottom" title="缴款人类型">
      <van-picker
        v-if="showType"
        title="缴款人类型"
        show-toolbar
        :columns="options"
        value-key="label"
        @confirm="onConfirm"
        :default-index="defaultIndex"
        @cancel="showType = false"
      />
    </van-popup> -->
  </div>
</template>

<script>
  

export default {
  props: {
    isRefNotice: {
      type: Boolean,
    },
    isShowPayNotice: {
      type: Boolean,
      default:false,
    },
    isBill: {
      type: Boolean,
    },
    isShowPhone: {
      type: Boolean,
    },
    isShowDialog: {
      type: Boolean,
    },
    checkArr: {
      type: Array,
    },
    payPromptInfo:{
      type:String
    },
  },
  data() {
    return {
      receiveBank:'',// 收款银行
      accountNumber:"", // 银行卡号
      accountBank:"", // 银行名称
      payer:"", // 缴款人
      showModel: false,
      detailData: [],
      detailList: [],
      curData: null,
      options: [
        { label: "个人", value: "1" },
        { label: "单位", value: "2" },
      ],
      showType: false,
      payerType: "",
      payerTypeName: "",
      phone: "",
      defaultIndex: 0,
      content:"*若遇不可抗力导致重庆地区考试取消，将按以下信息进行退费，请正确填写。",
    };
  },
  watch: {
    isShowDialog: {
      deep: true,
      handler(newV, oldV) {
        if (newV) {
          this.showModel = true;
          // this.phone = this.checkArr[0].phone ? this.checkArr[0].phone : "";
          // this.payerType = this.checkArr[0].payerType
          //   ? this.checkArr[0].payerType
          //   : "";
          this.accountNumber=this.checkArr[0].accountNumber
            ? this.checkArr[0].accountNumber
            : "";
          this.accountBank=this.checkArr[0].accountBank
            ? this.checkArr[0].accountBank
            : "";
          this.payer=this.checkArr[0].paymentUnit
            ? this.checkArr[0].paymentUnit
            : "";
          this.receiveBank=this.checkArr[0].receiveBank
            ? this.checkArr[0].receiveBank
            : ""
          // 从列表中选中项获取到缴款人 银行卡号  银行名称
          // this.phone = this.checkArr[0].phone ? this.checkArr[0].phone : "";
          
          // if (this.payerType) {
          //   this.options.forEach((item, index) => {
          //     if (item.value == this.payerType) {
          //       this.payerTypeName = item.label;
          //       this.defaultIndex = index;
          //     }
          //   });
          // }
          // this.content=this.payPromptInfo;
          // this.content=this.content.replaceAll("\n","<br/>");
          // this.content=this.content.replaceAll(" ","&nbsp;");
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
          document.body.style.height = '100%';
        }else {
          document.body.style.position = 'static';
          document.body.style.height = 'auto';
        }
      },
    },
  },
  methods: {
    closeDialog() {
      this.showModel = false;
      this.$refs.formPhone.resetValidation();
      this.$emit("closeDialog");
    },
    confirmPay() {
      this.accountBank=this.accountBank.trim();
      this.payer=this.payer.trim();
      this.receiveBank=this.receiveBank.trim();
      this.$refs.formPhone
          .validate()
          .then(() => {
            let info = [];
            this.checkArr.forEach((item) => {
              let obj = {
                bizId: item.uId,
                // sysType: item.sysType,
                // phone: this.phone,
                // payerType: this.payerType,
                accountNumber:this.accountNumber, // 银行卡号
                accountBank:this.accountBank, // 银行名称
                payer:this.payer, // 缴款人
                receiveBank:this.receiveBank // 收款银行
              };
              info.push(obj);
            });
            this.request({
              url: "/payBankAccountInput/bankAccountInput",
              method: "post",
              data: info,
            }).then((res) => {
              if (res.data.code == 1000) {
                // this.showModel = false;
                // this.$emit("closeBillPhonePay");
                this.showModel = false;
                this.$emit("payContinue");
              } else {
                this.$dialog
                  .alert({
                    title: "提示",
                    message: res.data.message,
                  })
                  .then(() => {});
              }
            });
          })
          .catch(() => {
          });
     
    },
    validator(val) {
      return /^1\d{10}$/.test(val) || val.trim() == "";
    },
    closePay(action, done) {
      if (action == "cancel") {
        this.showModel = false;
        this.$emit("closeDialog");
        done();
      } else {
        this.$refs.formPhone
          .validate()
          .then(() => {
            let info = [];
            this.checkArr.forEach((item) => {
              let obj = {
                uId: item.uId,
                sysType: item.sysType,
                phone: this.phone,
                payerType: this.payerType,
              };
              info.push(obj);
            });
            this.request({
              url: "/payPhoneInput/phoneInput",
              method: "post",
              data: info,
            }).then((res) => {
              if (res.data.code == 1000) {
                this.showModel = false;
                this.$emit("closeBillPhonePay");
              } else {
                this.$dialog
                  .alert({
                    title: "提示",
                    message: res.data.message,
                  })
                  .then(() => {});
              }
            });
            done();
          })
          .catch(() => {
            done(false);
          });
      }
    },
    onConfirm(val) {
      this.payerType = val.value;
      this.payerTypeName = val.label;
      this.showType = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.phoneBox {
  ::v-deep .van-field--disabled {
    background: #f5f7fa;
  }
  ::v-deep .van-field__control:disabled {
    color: #333 !important;
    -webkit-text-fill-color: #333 !important;
  }
  .phLabel {
    font-size: 14px;
  }
  ::v-deep .van-field__label {
    margin-right: 0px;
  }
  position: relative;
  > img {
    width: 14px;
    position: absolute;
    top: 16px;
    right: 10px;
  }
  .phInput {
    width: 63%;
  }
  .captchaClass {
    border: 1px solid #ebedf0;
    top: 18px;
    width: 87px;
    right: 0px;
  }
}
.billBox {
  position: relative;
  > img {
    width: 14px;
    position: absolute;
    top: 16px;
    right: 10px;
  }
}
.cBox {
  margin-top: 10px;
  ::v-deep .van-cell {
    padding: 4px 10px;
    margin-top: 4px;
    border: 0.02667rem solid #ebedf0;
    margin-bottom: 12px;
  }
  ::v-deep .van-cell::after {
    border-bottom: none !important;
  }
  ::v-deep .van-field__control {
    max-width: 80%;
  }
}
.notice {
  text-align: left;
  color: #f56c6c;
  line-height: 20px;
  padding: 0.1rem 0;
}
.cont {
  font-size: 14px;
  max-height: 186px;
  overflow-y: auto;
  padding: 10px 0px;
  padding-top: 0px;
  line-height: 24px;
  // padding-top: 20px;
  word-break: break-all;
  color: #f04f4f;
}
.ti {
  position: relative;
  text-align: center;
  // position: absolute;
  // top: 4%;
  // left: 50%;
  // z-index: 1001;
  // width: 86%;
  // transform: translateX(-50%); url("../assets/img/paybg.png")
  font-size: 16px;
  color: #fff;
  padding: 18px 0px;
  border-radius: 8px 8px 0px 0px;
  background: #1989fa;
  ::v-deep .van-divider {
    margin: 10px 0px !important;
    background: rgb(235, 235, 235) !important;
  }
}
.deta {
  display: flex;
  justify-content: space-between;
}
.showD {
  // position: fixed;
  // z-index: 1000;
  // height: 100vh;
  // width: 100vw;
  // background: rgba(0, 0, 0, 0.5);
  // top: 0%;
  // left: 50%;
  // transform: translateX(-50%);
}
.close {
  position: absolute;
  right: 20px;
  bottom: 10px;
  font-size: 30px;
  color: #fff;
  font-weight: 300;
}
.circle {
  width: 80px;
  height: 80px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -30%);
  border-radius: 50%;
  z-index: -1;
}
.dialogTitle {
  .van-dialog__header {
    background: #1989fa;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
  }
}
.content {
  width: 80vw;
  // border-radius: 8px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // width: 72%;
  // max-height: 75%;
  // transform: translate(-50%, -50%);
  // background: #fff;
  // text-align: left;
  // line-height: 24px;
  // ::v-deep .van-divider {
  //   background: rgb(235, 235, 235) !important;
  // }
  ::v-deep .van-form {
    box-shadow: none !important;
  }
}

.butarea {
  display: flex;
  padding: 10px 6px;
  padding-bottom: 20px;
  justify-content: space-around;
  .cancel {
    width: 120px;
    height: 40px;
    color: #777 !important;
  }
  .confirm {
    width: 120px;
    height: 40px;
    color: #fff !important;
  }
}
</style>